(function () {
  const selector = '[data-about-brand-accordion]';
  const instances = new Map();

  class AboutBrandAccordion {
    constructor(element) {
      this.element = element;
      this.container = this.element.querySelector('.about-brand-accordion__container');
      this.header = this.element.querySelector('.about-brand-accordion__header');
      this.handleClick = this.handleClick.bind(this);

      if (this.container && this.header) {
        this.header.addEventListener('click', this.handleClick);
      }
    }

    handleClick() {
      this.container.classList.toggle('expanded');
    }

    disconnect() {
      if (this.header) {
        this.header.removeEventListener('click', this.handleClick);
      }
    }
  }

  function getTargets(root) {
    const targets = [];

    if (root instanceof Element && root.matches(selector)) {
      targets.push(root);
    }

    if (root.querySelectorAll) {
      targets.push(...root.querySelectorAll(selector));
    }

    return targets;
  }

  function init(root) {
    getTargets(root).forEach((element) => {
      if (instances.has(element)) return;
      instances.set(element, new AboutBrandAccordion(element));
    });
  }

  function destroy(root) {
    getTargets(root).forEach((element) => {
      const instance = instances.get(element);
      if (!instance) return;

      instance.disconnect();
      instances.delete(element);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroy(event.target);
  });
})();
